import { put, takeLatest } from 'redux-saga/effects';
import { FETCH_STORIES } from '../actions/ActionTypes';

import { API_DOMAIN } from '../config/Constants';
import Utility from '../utils/Utility';
import {
  getApiHeaders,
  convertJsonFromResponse,
} from './GeneratorUtil';

export function* fetchStoriesAsync(action) {
  const {
    payload: slug,
    callback = () => {},
  } = action;
  const url = `${API_DOMAIN}${slug}`;
  try {
    const response = yield fetch(url, {
      method: 'GET',
      headers: yield getApiHeaders(),
    });
    if (response.status >= 200 && response.status < 300) {
      const json = yield convertJsonFromResponse(response);
      if (Utility.isBlank(json)) {
        callback(false);
        return;
      }
      callback(true, json);
      return;
    }
    callback(false);
  } catch (error) {
    callback(false);
  }
}

// Our watcher Saga:
export default function* watchFetchStories() {
  yield takeLatest(FETCH_STORIES, fetchStoriesAsync);
}
